import user from "./modules/user";
import guild from "./modules/guild";

export default {
  user,
  guild
}